/**
 * Action types for ACS scheduler functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_ACS_SCHEDULER = 'GET_ACS_SCHEDULER';
export const GET_ACS_SCHEDULER_SUCCESS = 'GET_ACS_SCHEDULER_SUCCESS';
export const GET_ACS_SCHEDULER_FAIL = 'GET_ACS_SCHEDULER_FAIL';

export const ADD_ACS_SCHEDULE = 'ADD_ACS_SCHEDULE';

export const EDIT_ACS_SCHEDULE = 'EDIT_ACS_SCHEDULE';
export const EDIT_ACS_SCHEDULE_FAIL = 'EDIT_ACS_SCHEDULE_FAIL';
export const EDIT_ACS_SCHEDULE_SUCCESS = 'EDIT_ACS_SCHEDULE_SUCCESS';
export const ACS_EDIT_SCHEDULE_SUCCESSS_MESSAGE =
	'ACS_SCHEDULE_UPDATED_SUCCESSFULLY';
export const RESET_ACS_SCHEDULE = 'RESET_ACS_SCHEDULE';
export const ACS_DELETE_SCHEDULE_SUCCESSS_MESSAGE =
	'ACS_SCHEDULE_DELETED_SUCCESSFULLY';
export const DELETE_ACS_SCHEDULE = 'DELETE_ACS_SCHEDULE';
export const DELETE_ACS_SCHEDULE_SUCCESS = 'DELETE_ACS_SCHEDULE_SUCCESS';
export const DELETE_ACS_SCHEDULE_FAIL = 'DELETE_ACS_SCHEDULE_FAIL';

export const ADD_ACS_SCHEDULE_REQUEST = 'ADD_ACS_SCHEDULE_REQUEST';
export const ADD_ACS_SCHEDULE_SUCCESS = 'ADD_ACS_SCHEDULE_SUCCESS';
export const ADD_ACS_SCHEDULE_FAIL = 'ADD_ACS_SCHEDULE_FAIL';
export const ADD_ACS_SCHEDULE_SUCCESS_MESSAGE =
	'ACS_SCHEDULE_ADDED_SUCCESSFULLY';
export const RESET_ACS_SCHEDULE_ADD = 'RESET_ACS_SCHEDULE_ADD';
